import MuiBox from '@new-components/atoms/MuiBox';
import {useAdvancedFilter} from '@new-components/templates/AdvancedFilters/Provider';
import {AdvancedFilterData} from '@new-components/templates/AdvancedFilters';
import {pushToQueryParams} from '@utils/new/navigation';
import {getQueryStr} from '@new-components/templates/SearchBox';

const ALLFilterIcon = () => {
  return (
    <svg
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3883_3650)'>
        <path
          d='M22.5835 22.584L26.3335 26.334'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M24.667 17.167C24.667 13.0249 21.3091 9.66699 17.167 9.66699C13.0249 9.66699 9.66699 13.0249 9.66699 17.167C9.66699 21.3091 13.0249 24.667 17.167 24.667C21.3091 24.667 24.667 21.3091 24.667 17.167Z'
          stroke='white'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_3883_3650'>
          <rect
            width='20'
            height='20'
            fill='white'
            transform='translate(8 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const MobAdvancedFilter = () => {
  const advancedFilter = useAdvancedFilter();
  const openAdvancedFilter = async () => {
    const data = await advancedFilter.show({} as AdvancedFilterData);
    if (data) {
      const queryStr = getQueryStr(data);
      pushToQueryParams(queryStr);
    }
  };
  return (
    <MuiBox
      sx={{
        display: {xs: 'block', sm: 'block', md: 'none'},
        marginLeft: 'auto',
      }}
      onClick={openAdvancedFilter}>
      <ALLFilterIcon />
    </MuiBox>
  );
};

export default MobAdvancedFilter;
